import type { PersonNames } from '../personnel/usePersonNames';

/**
 * What an applicant's Name shows, including when it cannot show one — the same answers
 * `personDisplayName` gives an employee, minus the employee number an applicant does not have:
 *
 * - resolved     the display name
 * - erased       said plainly — the identity was destroyed and is not coming back
 * - unavailable  the resolve failed; never a stale name, never an empty cell
 * - loading      an ellipsis, so the row does not read as nameless while the batch is in flight
 */
export function applicantDisplayName(personId: string, names: PersonNames): string {
  const resolved = names.nameOf(personId);

  if (resolved) return names.statusOf(personId) === 'erased' ? 'Identity erased' : resolved;
  if (names.failed) return 'Name unavailable';

  return '…';
}
